import { z } from 'zod';

import { isValidNpi } from '@/shared/lib/formatters/npi';
import { isValidNanpPhone } from '@/shared/lib/formatters/phone';
import { isValidZip } from '@/shared/lib/formatters/zip';

const DOB_RE = /^\d{2}\/\d{2}\/\d{4}$/;

/** Required date of birth in MM/DD/YYYY format. */
export const dobField = z
  .string()
  .trim()
  .min(1, 'Date of birth is required')
  .regex(DOB_RE, 'Date of birth must be in MM/DD/YYYY format');

/** Required ZIP code in 5-digit or ZIP+4 format. */
export const zipField = z
  .string()
  .trim()
  .min(1, 'ZIP code is required')
  .refine(isValidZip, 'ZIP code must be 5 digits or 5+4 format');

/** Required 10-digit NPI number. */
export const npiField = z
  .string()
  .trim()
  .min(1, 'NPI number is required')
  .refine(isValidNpi, 'NPI must be exactly 10 digits');

/** Required NANP phone: 10 digits, area code cannot start with 0 or 1. */
export const phoneField = z
  .string()
  .trim()
  .min(1, 'Phone number is required')
  .refine(isValidNanpPhone, 'Must be a valid 10-digit US phone number');

/** Optional (nullish) NANP phone — same check when present. */
export const phoneFieldOptional = z
  .string()
  .trim()
  .refine((v) => v === '' || isValidNanpPhone(v), 'Must be a valid 10-digit US phone number')
  .nullish();
